"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionLabels = exports.sectionOverrides = exports.labelOverrides = exports.fieldTypeOverrides = void 0;
// Belirli alanları zengin metne (TipTap) yükseltmek için: ns -> key -> 'richtext'.
// Bir alanı buraya eklediğinde, web tarafında o alanın render sitesini <RichText> ile değiştir (bkz. Task 14).
exports.fieldTypeOverrides = {
    // Görsel URL alanları: admin'de MediaPicker ile düzenlenir (auto-classify uzunluk yüzünden textarea sanıyordu).
    socialResponsibilityPage: {
        project1Image: "image",
        project2Image: "image",
        project3Image: "image",
        project4Image: "image",
        project5Image: "image",
    },
    aboutPage: {
        heroImage: "image",
    },
    layout: {
        logo: "image",
        favicon: "image",
    },
    // Belge (PDF) alanları: admin'de MediaPicker ile dosya seçilir, değer MinIO URL'idir.
    // Web tarafında bu sayfa artık metin render etmez; /kvkk-politikasi bu URL'e yönlenir.
    kvkkPage: {
        content: "file",
    },
    // Uzun, tek-blok açıklama alanları: zengin metin (TipTap). Web'de <RichText> ile render edilir.
    // Yeni alan promote etmek için: buraya 'richtext' ekle + render sitesini <RichText html={t.raw(key)} /> yap.
    hrPolicyPage: {
        introDesc: "richtext",
    },
    qualityPolicyPage: {
        heroDescription: "richtext",
    },
};
// Otomatik humanize yetersizse etiket düzeltmeleri: ns -> key -> etiket.
exports.labelOverrides = {
    kvkkPage: {
        content: "PDF Dosyası",
    },
};
// Alanı bir bölüme (sectionId) atar: ns -> key -> sectionId. ContentEditor bu bölümlere
// göre başlıklı gruplar. Bölümü olmayan alanlar "Genel" altında toplanır.
exports.sectionOverrides = {
    socialResponsibilityPage: {
        project1Image: "projects",
        project2Image: "projects",
        project3Image: "projects",
        project4Image: "projects",
        project5Image: "projects",
    },
    aboutPage: {
        heroImage: "hero",
    },
    layout: {
        logo: "brand",
        favicon: "brand",
    },
};
// Bölüm başlığı + sırası: ns -> sectionId -> { label, order }.
exports.sectionLabels = {
    socialResponsibilityPage: {
        projects: { label: "Proje Görselleri", order: 1 },
    },
    aboutPage: {
        hero: { label: "Hero", order: 1 },
    },
    layout: {
        brand: { label: "Logo & Marka", order: 1 },
    },
};
//# sourceMappingURL=overrides.js.map